<template>
  <div class="content">
    <van-sticky>
      <van-nav-bar title="编辑" left-arrow @click-left="goback()" />
    </van-sticky>

    <div class="lease_title">场地信息</div>

    <!-- 表单 -->
    <van-form
      label-width="100"
      class="lease_form"
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group>
        <van-field
          input-align="right"
          v-model="submitData.name"
          label="标题"
          placeholder="请输入"
          is-link
          required
          :rules="[{ required: true, message: '请输入标题' }]"
        />

        <van-field
          input-align="right"
          v-model="submitData.area"
          type="number"
          label="面积"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入面积' }]"
        >
          <template #extra>㎡</template>
        </van-field>

        <van-field
          input-align="right"
          required
          type="number"
          v-model="submitData.monthlyRent"
          label="月租金"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入月租金' }]"
        >
          <template #extra>元/月</template>
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="fieldValue"
          readonly
          label="所在位置"
          placeholder="请选择所在位置"
          @click="showCascader = true"
          :rules="[{ required: true, message: '请选择所在位置' }]"
        />
        
        <van-field
          input-align="right"
          required
          v-model="submitData.address"
          label="详细地址"
          placeholder="如（中山三路16号）"
          :rules="[{ required: true, message: '输入详细地址' }]"
        >
        <template #extra><span @click="blurValue" style="padding-left:10px;color:blue">查询位置</span></template> 
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="submitData.latitude"
          @blur="blurInputValue"
          label="纬度X坐标"
          placeholder="请输入纬度X坐标"
          :rules="[{ required: true, message: '输入经纬度用于获取准确地址定位' }]"
        >
        <!-- <template #extra><a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank" style="padding-left:10px;color:blue">查询经纬度</a></template> -->
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="submitData.longitude"
          @blur="blurInputValue"
          label="经度Y坐标"
          placeholder="请输入经度Y坐标"
          :rules="[{ required: true, message: '输入经纬度用于获取准确地址定位' }]"
        >
        <!-- <template #extra><a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank" style="padding-left:10px;color:blue">查询经纬度</a></template> -->
        </van-field>
        
        <baidu-map :center="center" :zoom="zoom" @ready="handler" @click="paintPolyline" style="height: 400px" :scroll-wheel-zoom="true">
          <!--定位-->
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
          <!--比例尺-->
          <bm-scale  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
          <!--缩放-->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        </baidu-map>

        <van-field
          input-align="right"
          required
          v-model="submitData.typeName"
          label="类型"
          placeholder="请输入"
          is-link
          readonly
          @click="showTypeList = true"
          :rules="[{ required: true, message: '请输入月租金' }]"
        />

        <van-action-sheet
          v-model="showTypeList"
          :actions="typeList"
          @select="onSelectTypeList"
        />

        <van-field
          input-align="right"
          required
          v-model="submitData.floorName"
          label="楼层"
          placeholder="请输入"
          is-link
          readonly
          @click="showFloorList = true"
          :rules="[{ required: true, message: '请输入楼层' }]"
        />

        <van-action-sheet
          v-model="showFloorList"
          :actions="floorList"
          @select="onSelectFloorList"
        />

        <van-field
          input-align="right"
          required
          v-model="submitData.levelName"
          label="等级"
          placeholder="请输入"
          is-link
          readonly
          @click="showLevelList = true"
          :rules="[{ required: true, message: '请输入等级' }]"
        />

        <van-action-sheet
          v-model="showLevelList"
          :actions="levelList"
          @select="onSelectLevelList"
        />

        <van-field
          input-align="right"
          required
          v-model="submitData.registerName"
          label="注册"
          placeholder="请输入"
          is-link
          readonly
          @click="showRegisterList = true"
          :rules="[{ required: true, message: '请输入注册' }]"
        />

        <van-action-sheet
          v-model="showRegisterList"
          :actions="registerList"
          @select="onSelectRegisterList"
        />

        <van-field
          input-align="right"
          required
          v-model="submitData.utilizationRate"
          label="使用率"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入使用率' }]"
        >
          <template #extra>%</template>
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="submitData.workstation"
          label="工位数"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入工位数' }]"
        >
          <template #extra>位</template>
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="submitData.renovationName"
          label="装修"
          placeholder="请输入"
          is-link
          readonly
          @click="showRenovationList = true"
          :rules="[{ required: true, message: '请输入装修' }]"
        />

        <van-action-sheet
          v-model="showRenovationList"
          :actions="renovationList"
          @select="onSelectRenovationList"
        />

        <van-field
          input-align="right"
          required
          type="number"
          v-model="submitData.propertyFee"
          label="物业费"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入物业费' }]"
        >
          <template #extra>元/月</template>
        </van-field>

        <div class="form_feature">
          <div class="fs14">
            场地特色(多选)
            <span style="font-size: 8px; color: red">*必须选中一项</span>
          </div>
          <div class="feature_list">
            <van-button
              native-type="button"
              :color="item.isCheck ? '#0CADFC' : '#DFDDDD'"
              v-for="(item, index) in siteCharacteristicsList"
              :key="index"
              @click="changeSiteOpentions(index)"
              >{{ item.itemText }}</van-button
            >
          </div>
        </div>

        <div class="house_detail">
          房源详情
          <van-field
            v-model="submitData.listingDetails"
            rows="2"
            autosize
            type="textarea"
            maxlength="300"
            placeholder="请详细介绍你的场地情况"
            show-word-limit
            :rules="[{ required: true, message: '请输入详细介绍你的场地情况' }]"
          />
        </div>

        <div class="lease_title">租赁信息</div>

        <van-field
          input-align="right"
          required
          v-model="submitData.rentFree"
          label="租期"
          placeholder="请输入"
          is-link
          readonly
          @click="showPicker = true"
        />

        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>

        <div class="form_feature">
          <div class="fs14">
            请勾选设置可租赁的套餐时长（多选）
            <span class="m-t10" style="color: #ff1313">*</span>
          </div>
          <div class="feature_list">
            <van-button
              native-type="button"
              :color="item.isCheck ? '#0CADFC' : '#DFDDDD'"
              v-for="(item, index) in leaseDurationList"
              :key="index"
              @click="changeLeaseDurationList(index)"
              >{{ item.itemText }}</van-button
            >
          </div>
        </div>

        <div class="lease_title">媒体信息</div>

        <div class="m-l20" style="color: #ff1313; font-size: 12px !important">
          <span class="m-t10">*</span>
          上传多张图片，并选择一张图片作为场地封面
        </div>

        <div class="img_content">
          <van-uploader :after-read="afterRead" accept="image/*" multiple>
            <div class="unimage">
              <van-icon
                name="/static/images/up_img.png"
                size="20"
                color="#898989"
              />
              <div>上传照片</div>
            </div>
          </van-uploader>
        </div>

        <div class="lease_uploader_list">
          <div class="list_img" v-for="(item, index) in imgList" :key="index">
            <van-image
              width="100%"
              @click.stop="previewImg(index)"
              :src="item.url"
              height="100%"
              fit="cover"
            />
            <van-icon
              class="img_checked"
              name="clear"
              size="20"
              color="#F70B0B"
              @click.stop="deleteUploadImg(index)"
            />
            <van-icon
              v-if="item.isImage"
              class="img_clear"
              name="checked"
              size="25"
              color="#0CADFC"
            />
          </div>
        </div>

        <div style="font-size: 12px; color: red; margin-left: 20px">
          *视频大小不能超过100M
        </div>

        <div class="img_content" style="margin-top: 10px; margin-bottom: 20px">
          <van-uploader
            v-model="videoList"
            :max-count="1"
            preview-size="90px"
            accept="video/*"
            :after-read="handlevideosc"
            :before-read="handlebefread"
            :before-delete="deleteUploadVideo"
          >
            <div slot="preview-cover" v-if="videourl">
              <video
                style="width: 90px; height: 90px; object-fit: cover"
                :src="videourl"
              ></video>
            </div>
            <div class="unimage" v-else>
              <van-icon
                name="/static/images/up_video.png"
                size="25"
                color="#898989"
              />
              <div>上传视频</div>
            </div>
          </van-uploader>
        </div>

        <video
          controls
          preload="auto"
          style="width: 100%; height: 200px; object-fit: contain"
          :src="videourl"
          v-if="videourl"
        ></video>
        <div class="m-l20" style="color: #ff1313; font-size: 12px !important">
          <span class="m-t10">*</span>
          上传房产证 可多张
        </div>

        <div class="img_content">
          <van-uploader :after-read="afterReadproperty" accept="image/*" multiple>
            <div class="unimage">
              <van-icon
                name="/static/images/up_img.png"
                size="20"
                color="#898989"
              />
              <div>上传房产证</div>
            </div>
          </van-uploader>
        </div>

        <div class="lease_uploader_list">
          <div
            class="list_img"
            v-if="item.type != 2"
            v-for="(item, index) in propertyCertificateFileIdList"
            :key="index"
          >
            <van-image
              width="100%"
              :src="item.url"
              height="100%"
              fit="cover"
            />
            <van-icon
              class="img_checked"
              name="clear"
              size="20"
              color="#F70B0B"
              @click.stop="deleteUploadImgFileIdList(index)"
            />

          </div>
        </div>
        <div class="lease_title">联系信息</div>

        <van-field
          input-align="right"
          required
          v-model="submitData.contactName"
          label="姓名"
          is-link
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />

        <van-field
          required
          input-align="right"
          v-model="submitData.contactGenderName"
          label="性别"
          placeholder="请选择性别"
          is-link
          readonly
          @click="showSexsOptions = true"
          :rules="[{ required: true, message: '请选择性别' }]"
        />

        <van-field
          is-link
          input-align="right"
          required
          v-model="submitData.contactNumber"
          label="手机号"
          placeholder="请输入"
          :rules="[
            { required: true },
            { pattern: /^1[3456789]\d{9}$/, message: '手机格式错误！' },
          ]"
        />

        <div class="form_btn">
          <van-button block color="#0CA7F0" type="info" native-type="submit"
            >立即发布</van-button
          >
        </div>
      </van-cell-group>
    </van-form>

    <van-popup v-model="showCascader" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="showCascader = false"
        @finish="onFinish"
        :field-names="{
          text: 'name',
          value: 'area_code',
          children: 'children',
        }"
      />
    </van-popup>

    <van-action-sheet
      v-model="showSexsOptions"
      :actions="genderList"
      @select="onSelectType"
    />

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#fff" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Video from "./components/video";
import {
  Button,
  Icon,
  Uploader,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Tag,
  Cascader,
  Popup,
  ActionSheet,
  Picker,
  Loading,
  Overlay,
  Dialog,
} from "vant";
import common from "@/utils/common";
import cityData from "@/assets/js/city.js";
import storage from "@/utils/storage";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Dialog.name]: Dialog,
    Video,
  },

  data() {
    return {
      show: false,

      carinfo: {
        videofile: "",
        ngEcoOpenNo: "",
      },
      propertyCertificateFileIdList:[],
      videoList: [],
      videourl: "",
      showvideoplay: false,

      imgList: [],

      submitData: [],

      submitDatas: {
        id: "",
        name: "",
        area: "",
        monthlyRent: "",
        province: "",
        city: "",
        district: "",
        position: "",
        address: "",
        longitude: "",
        latitude: "",
        type: "",
        floor: "",
        level: "",
        register: "",
        utilizationRate: "",
        workstation: "",
        renovation: "",
        propertyFee: "",
        siteCharacteristics: "",
        listingDetails: "",
        paymentType_deposit: "1",
        paymentType_payment: "2",
        rentFree_begin: "",
        rentFree_count: "",
        leaseDuration: "",
        contactName: "",
        contactGender: "",
        contactNumber: "",
        coverImageId: "",
        fileIdList: [],
        propertyCertificateFileIdList: [],
      },

      typeList: [], //类型列表
      showTypeList: false,
      floorList: [], //楼层列表
      showFloorList: false,

      registerList: [], //注册列表
      showRegisterList: false,
      renovationList: [], //装修
      showRenovationList: false,
      levelList: [],
      showLevelList: false,

      genderList: [], //性别
      showSexsOptions: false,

      siteCharacteristicsList: [], //场地特色
      leaseDurationList: [], //租赁时长

      showCascader: false,
      fieldValue: "",
      cascaderValue: "",
      options: [],

      // columns: [
      //   // 第一列
      //   {
      //     values: [1, 2, 3, 4, 5],
      //     defaultIndex: 2,
      //   },
      //   // 第二列
      //   {
      //     values: [1, 2, 3, 4, 5],
      //     defaultIndex: 1,
      //   },
      // ],

      columns: [
        // 第一列
        {
          values: [],
          defaultIndex: 2,
        },
        // 第二列
        {
          values: [],
          defaultIndex: 1,
        },
      ],

      showPicker: false,

      fileId: [627, 628, 644],

      center: { lng: "", lat: "" }, //lng代表纬度 lat代表经度
      zoom: 16,
      BMap:'',
      map:'',
    };
  },

  //初始化加载
  created() {
    this.options = cityData.data;
    //场地方管理-编辑
    this.siteAdd();
    //员工管理-查看
    this.siteDetail(this.$route.query.id);

    for(let i = 1; i <= 60; i++){
      let k = i - 1;
      this.columns[0].values[k] = i;
      this.columns[1].values[k] = i;
    }
    this.columns[1].values.unshift(0);
  },

  methods: {
    // 员工管理-查看
    siteDetail(id) {
      var that = this;
      that.$api
        .siteDetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            var data = res.data.data;

            that.fieldValue =
              data.province + "/" + data.city + "/" + data.district + "";

            data.typeName = data.type_name/*that.typeList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.floorName = data.floor_name/*that.floorList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.levelName = data.level_name/*that.levelList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.registerName = data.register_name/*that.registerList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.contactGenderName = data.contactGender_name/*that.genderList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.renovationName = data.renovation_name/*that.renovationList.filter(
              (item) => (item.id = data.type)
            )[0].name;*/

            data.siteCharacteristics.split(",").forEach(function (element) {
              that.siteCharacteristicsList.forEach(function (elements) {
                if (element === elements.itemId) {
                  elements.isCheck = true;
                }
              });
            });

            data.leaseDuration.split(",").forEach(function (element) {
              that.leaseDurationList.forEach(function (elements) {
                if (element === elements.itemId) {
                  elements.isCheck = true;
                }
              });
            });

            if (data.videoList.length > 0) {
              that.videourl = data.videoList[0].url;
              that.videoList = data.videoList;
            }
            
            that.imgList = data.imageList;
            that.propertyCertificateFileIdList = data.propertyCertificateImageList
   
            that.submitData = data;
            that.makerCenter();
            console.log(that.submitData)
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

     blurInputValue(value){
      this.makerCenter()
    },

    blurValue(value) {
      this.latitude();
    },

    latitude() {
      this.$jsonp("https://apis.map.qq.com/ws/geocoder/v1/", {
        address:
          this.submitData.province +
          this.submitData.city +
          this.submitData.position,
        output: "jsonp",
        key: "5WNBZ-2JYR6-SPUSL-M3WGH-U4KDT-K2FYV",
      })
        .then((json) => {
          // 得到我们想要的内容
          if (json.status === 0) {
            this.address =
              this.submitData.province +
              this.submitData.city +
              this.submitData.province +
              this.submitData.position;
            this.submitData.longitude = json.result.location.lng;
            this.submitData.latitude = json.result.location.lat;
            this.makerCenter()
          } else {
            this.$Notify({
              type: "warning",
              message: "请选择输入正确地址用于获取经纬度",
            });
          }
        })
        .catch((err) => {});
    },

    handlebefread(e) {
      if (e.size > 104857600) {
        this.$Notify({
          type: "warning",
          message: "选择/录制视频不能超过100M",
        });
        return false;
      }
      return true;
    },

    handlevideosc(file) {
      this.videourl = file.content;
      // 上传附件到后台
      this.uploadSingleFile(file);
    },

    deleteUploadVideo() {
      this.videoList = [];
      this.videourl = "";
    },

    deleteUploadImg(index) {
      this.imgList.splice(index, 1);
      var data = [];
      this.imgList.forEach(function (item, key) {
        data.push(item.id);
      });
      if (this.imgList.length === 0) {
        this.submitData.coverImageId = "";
      }
      this.submitData.fileIdList = data;
      console.log("sd", this.submitData.fileIdList);
    },

    deleteUploadImgFileIdList(index) {
      this.propertyCertificateFileIdList.splice(index, 1);
      var data = [];
      this.propertyCertificateFileIdList.forEach(function (item, key) {
        data.push(item.id);
      });
      if(this.propertyCertificateFileIdList.length > 0)
      this.propertyCertificateFileIdList[0].isImage = true
      this.submitData.propertyCertificateFileIdList = data;
    },
    previewImg(index) {
      var that = this;
      that.imgList.forEach((element, item) => {
        if (index === item) {
          element.isImage = true;
          that.submitData.coverImageId = element.id;
          that.submitData.coverImageUrl = element.url;
        } else {
          element.isImage = false;
        }
      });
    },
    //文件读取完回调函数
    afterReadproperty(files) {
      var that = this;
      // 上传附件到后台
      that.uploadSingleFileProperty(files);
    },

    // 上传附件到后台
    uploadSingleFileProperty(files) {
      var that = this;
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.show = true;
      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadSingleFile",
          fromdata,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.show = false;
            that.propertyCertificateFileIdList.push({
              url: res.data.data.url,
              isImage: false,
              id: res.data.data.id,
              type: res.data.data.type,
            });
            that.propertyCertificateFileIdList[0].isImage = true;
            that.$Notify({
              type: "success",
              message: "上传成功",
            });
          }
          console.log(res.data);
        });
    },
    //文件读取完回调函数
    afterRead(files) {
      var that = this;
      // 上传附件到后台
      that.uploadSingleFile(files);
    },

    // 上传附件到后台
    uploadSingleFile(files) {
      var that = this;
      const fromdata = new FormData();
      fromdata.append("uploadfile", files.file);
      that.show = true;
      that.$axios
        .post(
          process.env.API_ROOT + "tgy/mobile/attachment/uploadSingleFile",
          fromdata,
          {
            headers: {
              enctype: "multipart/form-data",
              Authorization: storage.getUserInfo(),
            },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            that.show = false;
            console.log("res.data", res.data.data);
            if (res.data.data.type === "0") {
              that.imgList.push({
                url: res.data.data.url,
                isImage: false,
                id: res.data.data.id,
                type: res.data.data.type,
              });
              that.imgList[0].isImage = (that.submitData.coverImageId == '')?true:that.imgList[0].isImage;
              that.submitData.coverImageId = (that.submitData.coverImageId == '')?that.imgList[0].id:that.submitData.coverImageId;
            } else if (res.data.data.type === "2") {
              that.videoList = [];
              that.videoList.push(res.data.data);
              that.videourl = res.data.data.url;
            }

            that.$Notify({
              type: "success",
              message: "上传成功",
            });
          }
          console.log(res.data);
        });
    },

    onConfirm(value) {
      // value = value.join(",");
      // this.submitData.rentFree =
      //   "起租" + value[0] + "个月/免租" + value[2] + "个月";
      // this.submitData.rentFree_begin = value[0];
      // this.submitData.rentFree_count = value[2];
      // this.showPicker = false;
      this.submitData.rentFree =
        "起租" + this.columns[0].values[value[0]-1] + "个月/免租" + this.columns[1].values[value[1]] + "个月";
      this.submitData.rentFree_begin = this.columns[0].values[value[0]-1];
      this.submitData.rentFree_count = this.columns[1].values[value[1]-1];
      this.showPicker = false;
    },

    //选中场地特色
    changeSiteOpentions(index) {
      this.siteCharacteristicsList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = !element.isCheck;
        }
      });

      this.submitData.siteCharacteristics = this.siteCharacteristicsList
        .filter((item) => item.isCheck === true)
        .map((option) => option.itemId)
        .join(",");
    },

    //租赁时长
    changeLeaseDurationList(index) {
      this.leaseDurationList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = !element.isCheck;
        }
      });

      this.submitData.leaseDuration = this.leaseDurationList
        .filter((item) => item.isCheck === true)
        .map((option) => option.itemId)
        .join(",");
    },

    onSelectType(item) {
      this.submitData.contactGender = item.value;
      this.submitData.contactGenderName = item.name;
      this.showSexsOptions = false;
    },

    onSelectTypeList(item) {
      this.submitData.type = item.value;
      this.submitData.typeName = item.name;
      this.showTypeList = false;
    },

    onSelectFloorList(item) {
      this.submitData.floor = item.value;
      this.submitData.floorName = item.name;
      this.showFloorList = false;
    },

    onSelectLevelList(item) {
      this.submitData.level = item.value;
      this.submitData.levelName = item.name;
      this.showLevelList = false;
    },

    onSelectRegisterList(item) {
      this.submitData.register = item.value;
      this.submitData.registerName = item.name;
      this.showRegisterList = false;
    },

    onSelectRenovationList(item) {
      this.submitData.renovation = item.value;
      this.submitData.renovationName = item.name;
      this.showRenovationList = false;
    },

    //场地方管理-编辑
    siteAdd() {
      var that = this;
      that.$api
        .siteAddAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            var typeList = res.data.data.typeList;
            typeList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.typeList = typeList;
            that.submitData.type = typeList[0].itemId;
            that.submitData.typeName = typeList[0].itemText;

            var floorList = res.data.data.floorList;
            floorList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.floorList = floorList;
            that.submitData.floor = floorList[0].itemId;
            that.submitData.floorName = floorList[0].itemText;

            var levelList = res.data.data.levelList;
            levelList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.levelList = levelList;
            that.submitData.level = levelList[0].itemId;
            that.submitData.levelName = levelList[0].itemText;

            var registerList = res.data.data.registerList;
            registerList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.registerList = registerList;
            that.submitData.register = registerList[0].itemId;
            that.submitData.registerName = registerList[0].itemText;

            var renovationList = res.data.data.renovationList;
            renovationList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.renovationList = renovationList;
            that.submitData.renovation = renovationList[0].itemId;
            that.submitData.renovationName = renovationList[0].itemText;

            //性别
            var genderList = res.data.data.genderList;
            genderList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });
            that.genderList = genderList;
            that.submitData.contactGender = genderList[0].itemId;
            that.submitData.contactGenderName = genderList[0].itemText;

            //场地特色
            var siteCharacteristicsList = res.data.data.siteCharacteristicsList;
            siteCharacteristicsList.forEach((element, index) => {
              if (index === 0) {
                element.isCheck = true;
              } else {
                element.isCheck = false;
              }
            });

            that.siteCharacteristicsList = siteCharacteristicsList;
            that.submitData.siteCharacteristics =
              siteCharacteristicsList[0].itemId;

            //租赁时长
            var leaseDurationList = res.data.data.leaseDurationList;
            leaseDurationList.forEach((element, index) => {
              if (index === 0) {
                element.isCheck = true;
              } else {
                element.isCheck = false;
              }
            });

            that.leaseDurationList = leaseDurationList;
            that.submitData.leaseDuration = leaseDurationList[0].itemId;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      var info = selectedOptions.map((option) => option.name);
      this.fieldValue = selectedOptions.map((option) => option.name).join("/");
      this.submitData.province = info[0];
      this.submitData.city = info[1];
      this.submitData.district = info[2];
      this.showCascader = false;
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    onSubmit() {
      var that = this;

      if (that.imgList.length === 0 && that.videoList.length === 0) {
        that.$Notify({
          type: "warning",
          message: "请上传图片或上传视频",
        });
        return;
      }/*else if(that.propertyCertificateFileIdList.length === 0){
        that.$Notify({
          type: "warning",
          message: "请上传房产证",
        });
        return;
      } */else if(that.imgList.length > 0 && that.submitData.coverImageId === "" ){
         that.$Notify({
              type: "warning",
              message: "请选择一张图片作为场地封面图",
            });
            return;
      
      }else if (
        that.submitData.longitude === "" ||
        that.submitData.latitude === ""
      ) {
        that.$Notify({
          type: "warning",
          message: "请输入经纬度",
        });
        return;
      } else if (
        that.submitData.rentFree_begin === "" ||
        that.submitData.rentFree_count === ""
      ) {
        that.$Notify({
          type: "warning",
          message: "请选择租期",
        });
        return;
      } else if (that.submitData.monthlyRent < 0) {
        that.$Notify({
          type: "warning",
          message: "租金不能小于0",
        });
      } else if (that.submitData.area < 0) {
        that.$Notify({
          type: "warning",
          message: "面积不能小于0",
        });
      } else {

        if (that.imgList.length > 0) {
          that.imgList.forEach(function (element) {
            if (element.type === "0" && that.submitData.coverImageId === "") {
              that.$Notify({
                type: "warning",
                message: "请选择一张图片作为场地封面图",
              });
              return;
            }
            that.submitData.fileIdList.push(element.id);
          });
        }
        
        /*if (that.imgList.length > 0) {
          that.imgList.forEach(function (element) {
            that.submitData.fileIdList.push(element.id);
          });
        }*/

        if (that.videoList.length > 0) {
          that.submitData.fileIdList.push(that.videoList[0].id);
        }
        that.propertyCertificateFileIdList.forEach(function (element) {
          that.submitData.propertyCertificateFileIdList.push(element.id);
        });
        that.$delete(that.submitData, "type_name");
        that.$delete(that.submitData, "floor_name");
        that.$delete(that.submitData, "level_name");
        that.$delete(that.submitData, "register_name");
        that.$delete(that.submitData, "renovation_name");
        that.$delete(that.submitData, "contactGender_name");

        that.$delete(that.submitData, "typeName");
        that.$delete(that.submitData, "floorName");
        that.$delete(that.submitData, "levelName");
        that.$delete(that.submitData, "registerName");
        that.$delete(that.submitData, "renovationName");
        that.$delete(that.submitData, "contactGenderName");

        that.$delete(that.submitData, "rentFree");

        that.$delete(that.submitData, "broker_name");
        that.$delete(that.submitData, "broker_number");
        that.$delete(that.submitData, "broker_portrait");
        that.$delete(that.submitData, "broker_qrcode");
        that.$delete(that.submitData, "shelfStatus");
        that.$delete(that.submitData, "shelfStatus_name");
        that.$delete(that.submitData, "modifytime");

        that.$delete(that.submitData, "coverImageUrl");
        that.$delete(that.submitData, "imageList");
        that.$delete(that.submitData, "pdfList");
        that.$delete(that.submitData, "videoList");

        that.$delete(that.submitData, "site_supplier_id");
        that.$delete(that.submitData, "site_supplier_name");
        that.$delete(that.submitData, "siteCharacteristics_name");
        that.$delete(that.submitData, "paymentType");
        that.$delete(that.submitData, "leaseDuration_name");

        that.$delete(that.submitData, "siteCharacteristics_name");
        that.$delete(that.submitData, "paymentType");

        const res = new Map();
        that.submitData.fileIdList = that.submitData.fileIdList.filter(
          (arr) => !res.has(arr) && res.set(arr, 1)
        );
        that.submitData.position = that.submitData.province + that.submitData.city
        var param = {
          data: JSON.stringify(that.submitData),
        };

        that.$api
          .siteSaveAPI(param)
          .then(function (res) {
            if (res.data.code === 200) {
              that.$Notify({
                type: "success",
                message: "操作成功",
                onClose() {
                  that.$router.push({ path: "EditPlaceSuccess" });
                },
              });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
      }
    },

    //百度地图
    handler({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      var point = new BMap.Point(this.submitData.latitude?this.submitData.latitude:0, this.submitData.longitude?this.submitData.longitude:0);
      map.centerAndZoom(point, 25);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var circle = new BMap.Circle(point, 1, {
        strokeColor: "Red",
        strokeWeight: 1,
        strokeOpacity: 1,
        Color: "Red",
        fillColor: "#f03",
      });
      map.addOverlay(circle);
      //跳动的动画
      marker.setAnimation(BMAP_ANIMATION_BOUNCE);
    },

    // 坐标添加
    makerCenter() {
      let point = {lng:this.submitData.longitude,lat:this.submitData.latitude}
      this.center.lng = this.submitData.longitude;
      this.center.lat = this.submitData.latitude;
        if (this.map) {
          this.map.clearOverlays();
          var marker = new this.BMap.Marker(point);
          this.map.addOverlay(new this.BMap.Marker(point));
          //跳动的动画
          // eslint-disable-next-line no-undef
          marker.setAnimation(BMAP_ANIMATION_BOUNCE);
          // this.mapCenter.lng = this.submitData.longitude;
          // this.mapCenter.lat = this.submitData.latitude;
          this.mapZoom = 17;
          this.mapCenter= { lng: this.submitData.longitude, lat: this.submitData.latitude }
        }
      },

      // 点击 点击标注图标后会触发此事件
      paintPolyline(item) {
        console.log(item)
        let { point } = item;
        this.submitData.longitude = point.lng;
        this.submitData.latitude = point.lat;
        this.makerCenter();
      },
  },
};
</script>

<style lang="less" scoped>
.content {
  .form_feature {
    color: #646566;
    margin: 15px 10px;

    .feature_list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;

      .van-button {
        height: 35px;
        margin-top: 15px;
        width: 105px;
        border-radius: 4px;
      }
    }

    .feature_server {
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      margin-top: 15px;
      align-items: center;

      .server_btn {
        display: flex;
        justify-content: space-between;

        .van-button {
          width: 100px;
          margin-left: 15px;
        }
      }
    }
  }

  .lease_title {
    font-size: 16px;
    font-weight: bold;
    border-top: 1px solid #f4f3f8;
    padding: 15px;
  }

  .lease_uploader {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #999;

    .van-uploader {
      border-radius: 2px;
      background-color: rgba(0, 0, 0, 0.02);
      width: 90px;
      height: 90px;
      margin-left: 15px;
      border: 1px dashed rgba(0, 0, 0, 0.15);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-radius: 5px;
    }

    .img_license {
      border-radius: 2px;
      background-color: rgba(0, 0, 0, 0.02);
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.15);
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  .lease_uploader_list {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 15px;

    .list_img {
      width: 105px;
      height: 105px;
      margin-right: 10px;
      position: relative;
      margin-top: 10px;

      .img_checked {
        position: absolute;
        top: 5px;
        right: 10px;
      }

      .img_clear {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .house_detail {
    font-size: 14px;
    border-top: 1px solid #f4f3f8;
    padding: 15px;
    display: flex;
    flex-direction: column;

    /deep/ .van-cell {
      padding: 5px 10px;
      margin: 10px 0px !important;
      background: #f4f3f8 !important;
      font-weight: normal;

      textarea {
        height: 100px !important;
      }
    }
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .van-button {
    height: 35px;
  }

  .form_btn {
    border-radius: 1000px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    width: 100%;

    .van-button {
      height: 44px;
      width: 100%;
      border-radius: 0px;
    }
  }
}

.img_content {
  padding: 0px 20px;
  margin-top: 20px;

  .unimage {
    border-radius: 2px;
    background-color: rgba(0, 0, 0, 0.02);
    width: 100px;
    height: 100px;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #999;
  }

  /deep/ .van-uploader__preview-image {
    width: 100px;
    height: 100px;
  }
}

.van-ellipsis {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/place/placeEdit.vue